import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Plus, Check, ArrowRight } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { useLang } from "@/context/LanguageContext";
import { pickL } from "@/lib/content";

export default function ProductCard({ product }) {
  const { addItem } = useCart();
  const { t, lang } = useLang();
  const [added, setAdded] = useState(false);
  const outOfStock = typeof product.stock === "number" && product.stock <= 0;

  const handleAdd = () => {
    addItem(product, 1);
    setAdded(true);
    setTimeout(() => setAdded(false), 2000);
  };

  return (
    <article className={`product-card ${outOfStock ? "is-oos" : ""}`} data-testid={`product-card-${product.id}`}>
      <Link to={`/products/${product.id}`} aria-label={`Voir le détail de ${product.name}`}>
        <div className="product-image-wrap">
          <img src={product.image} alt={`${product.name} — ${product.subtitle}`} loading="lazy" />
          {outOfStock ? (
            <span className="product-badge oos" data-testid={`oos-badge-${product.id}`}>{t("product.soldOut")}</span>
          ) : product.on_sale ? (
            <span className="product-badge promo">Promo</span>
          ) : product.badge ? (
            <span className="product-badge">{product.badge}</span>
          ) : null}
        </div>
      </Link>
      <div className="product-body">
        <h3 className="product-name">{product.name}</h3>
        <p className="product-subtitle">{pickL(product, "subtitle", lang)}</p>
        <p className="product-desc">{pickL(product, "short_desc", lang)}</p>
        <div className="product-footer">
          {product.on_sale ? (
            <span className="product-price">
              <span className="price-old">€{product.price.toFixed(2).replace(".", ",")}</span>
              <span className="price-sale">€{product.effective_price.toFixed(2).replace(".", ",")}</span>
            </span>
          ) : (
            <span className="product-price">€{product.price.toFixed(2).replace(".", ",")}</span>
          )}
          <span className="product-certif">{product.certif}</span>
        </div>
      </div>
      <div className="product-actions">
        <button
          className={`btn-add ${added ? "added" : ""}`}
          onClick={handleAdd}
          disabled={outOfStock}
          aria-label={outOfStock ? `${product.name} indisponible` : `Ajouter ${product.name} au panier`}
          data-testid={`add-to-cart-${product.id}`}
        >
          {outOfStock ? t("product.unavailable") : (added ? <Check size={13} /> : <Plus size={13} />)}
          {outOfStock ? null : (added ? t("common.added") : t("common.addToCart"))}
        </button>
        <Link to={`/products/${product.id}`} className="btn-view" aria-label="Voir le détail" data-testid={`view-${product.id}`}>
          <ArrowRight size={14} />
        </Link>
      </div>
    </article>
  );
}
